export var CountryRegion;
(function (CountryRegion) {
    CountryRegion["Unspecified"] = "unspecified";
    CountryRegion["AMER"] = "AMER";
    CountryRegion["EMEA"] = "EMEA";
    CountryRegion["APAC"] = "APAC";
    CountryRegion["LATAM"] = "LATAM";
})(CountryRegion || (CountryRegion = {}));
//# sourceMappingURL=Country.js.map